import React, { useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';

import FloatingLayerPublic from '../front/FloatingLayerPublic';
import ButtonCollection from '../builder/ButtonCollection.js';

const reportClick = (net, promotion_id) => {
	$.post(`/v24/networks/click/${promotion_id}`, {
		id:net.id,
		type:net.net,
	});
};

const getNetworkLink = (net) => {
	switch(net.net) {
		case 'facebook':
			return (net.target.indexOf('facebook.com') != -1) ? net.target : `https://www.facebook.com/${net.target}`;

		case 'twitter':
			return (net.target.indexOf('twitter.com') != -1 || net.target.indexOf('//x.com') != -1 || net.target.indexOf('www.x.com') != -1) ? net.target : `https://twitter.com/${net.target}`;

		case 'instagram':
			return (net.target.indexOf('instagram.com') != -1) ? net.target : `https://www.instagram.com/${net.target}`;

		case 'pinterest':
			return (net.target.indexOf('pinterest.com') != -1) ? net.target : `https://www.pinterest.es/${net.target}`;

		case 'linkedin':
			return (net?.target != undefined && net.target.indexOf('linkedin.com') != -1) ? net.target : `https://www.linkedin.com/company/${net.target_user}`;

		case 'twitch':
			return (net.target.indexOf('twitch.tv') != -1) ? net.target : `https://www.twitch.tv/${net.target}`;

		case 'tiktok':
			return (net.target.indexOf('tiktok.com') != -1) ? net.target : `https://www.tiktok.com/@${net.target}`;

		case 'threads':
			return (net.target.indexOf('threads.net') != -1) ? net.target : `https://www.threads.net/@${net.target}`;

		case 'youtube':
			const user = (isNotEmpty(net, 'target_user')) ? net.target_user : net.target;

			let link_user = 'https://www.youtube.com/';
			if(!(net.target_user != undefined && net.target_user != '')) link_user += 'channel/';

			return (user.indexOf('youtube') != -1) ? user : link_user + user;
	}

	return false;
};

const DefaultNetButton = ({ net, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const type = net.net;

	const user = (props?.user ?? (net?.target ?? '')).replace("@", "");
	const show_username = net?.show_user ?? true;

	let label = `${i18n(props?.default_label ?? "Follow")}`;
	if(isNotEmpty(props, 'children')) label = i18n(props.children);

	return (
		<div class={`single_net is_$${type}`}>
			<p class={`net_description ${props?.icon ?? `ep-${type}`}`}>{(show_username) ? `@${user}` : ''}</p>

			<ButtonCollection _class={{ other:'flex_button' }}>
				<ActionButton
					_fullclass={`netButton is_${type}`}
					color={false}
					onClick={() => reportClick(net, props.promotion_id)}
					_href={getNetworkLink(net)}
					_target="_blank"
					autotranslate={false}
				>{label}</ActionButton>
			</ButtonCollection>
		</div>
	)
};

const MyNetworks = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const [ closed, setClosed ] = useState(false);

	const default_section_title = i18n("Follow us");
	const default_section_description = i18n("Still not a fan? Click on Like and Follow Us");
	const section = props.promotion?.my_networks?.sections[0] ?? {};

	const networks = props?.networks ?? (section?.nets ?? []);
	
	//if (networks == undefined) networks.push({});

	const is_builder = props.is_builder ?? false;

	if(closed/* || networks.length == 0*/) return null;

	let layer_title = `<h1>${(isNotEmpty(section, 'text')) ? section.text : default_section_title}</h1>`;
	if((section?.description ?? " ") != " ") layer_title += `<p>${(isNotEmpty(section, 'description')) ? section.description : default_section_description}</p>`;
	//layer_title += (isNotEmpty(networks[0], 'text')) ? `<p>${networks[0].text}</p>` : `<p>${i18n("Still not a fan? Click on Like and Follow Us")}</p>`;

	return (
		<FloatingLayerPublic
			pm={props.promotion}
			is_builder={is_builder}
			title={layer_title}
			backButton={props.close}
			footer_buttons={
				<ButtonCollection>
					<ActionButton
						_fullclass="in_top"
						onClick={() => props.close('button')}
					>Continue</ActionButton>
				</ButtonCollection>
			}
		>
			<div class="gui_my_networks gui_not_in_top_big">
				{networks.map((network, n) => {
					let url = null;
					let full_url = null;
					let icon = null;
					let user = null;
					let children = null;
					switch(network.net) {
						case 'facebook':
							user = network.target.replace(/(https?:\/\/)?(www\.)?facebook.com\//,"");
							url = 'https://facebook.com/';
							children = "Go to page";
							break;

						case 'pinterest':
							url = 'https://www.pinterest.com/';
							break;

						case 'twitter':
							url = 'https://twitter.com/intent/follow?screen_name=';
							break;

						case 'instagram':
							url = 'https://www.instagram.com/';
							break;

						case 'youtube':
							if(network.net_type == 'like_box') {
								full_url = `https://youtube.com/channel/${network.target}?sub_confirmation=1`;
							} else {
								//url = `https://youtube.com/${(network.target_user != '') ? network.target_user : `channel/${network.target}`}`;
								url = `https://youtube.com/${(network.target_user != '') ? '' : `channel/`}`;
								user = network.target_user != '' ? network.target_user : null;
								children = "Go to channel";
							}
							user = network.target_user;
							break;

						case 'linkedin':
							url = 'https://www.linkedin.com/company/';
							user = network.target_user;
							icon = 'ep-linked-in';
							break;

						case 'twitch':
							url = 'https://www.twitch.tv/';
							break;

						case 'tiktok':
							url = 'https://www.tiktok.com/';
							icon = 'ep-tik-tok';
							break;

						case 'threads':
							url = 'https://www.threads.net/';
							icon = 'ep-threads';
							break;
					}

					if(url == undefined && full_url == undefined) return null;

					return (
						<DefaultNetButton
							key={`n_${n}`}
							net={network}
							url={url}
							full_url={full_url}
							user={user}
							icon={icon}
							promotion_id={props?.promotion?.id ?? false}
							intl={props.intl}
						>{children}</DefaultNetButton>
					)
				})}
			</div>
		</FloatingLayerPublic>
	)
};

export default injectIntl(MyNetworks);